import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from  "@angular/common/http";
import { constVariables } from "../../constants/ConstantPath";

@Injectable({
  providedIn: 'root'
})
export class HotelhomeService {
	
  	constructor(private http: HttpClient) { }
	getHotelRooms(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Home/get_hotel_rooms";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}

	getRoomDetails(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Home/get_room_data";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getRateRuleData(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Home/getRateRuleData";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getSearchResults(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Searchresults/get_search_results";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
	getHotelAmenities(data) {
		let promise = new Promise((resolve, reject) => {
		    const url = constVariables.apiUrl +"frontend/Home/get_hotel_amenities";
		    this.http.post<any[]>(url,data).subscribe((res: any) => {
		    	resolve(res);
		    });
		});
		return promise;
	}
}
